module.exports = {
  platform: 'voice',
  name: 'Intent mapping',
  node: 'intent_mapping',
  bg: '#FFFFFF',
  note: '',
  property: {
    intent_variable: '',
    mapping: []
  }
}
